import "primereact/resources/themes/lara-light-blue/theme.css"; 
import "primereact/resources/primereact.min.css";               
import "primeicons/primeicons.css";                             
import "quill/dist/quill.snow.css";
import React, { useState, useEffect } from 'react';
import { PrimeReactProvider } from 'primereact/api'; 
import { Routes, Route, BrowserRouter, useNavigate,Navigate } from 'react-router-dom';
import './App.css';
import MainDash from './pages/MainDash/MainDash';
import ProductAdd from './pages/Product/ProductAdd';
import ProductSearch from './pages/Product/ProductSearch';
import Sidebar from './components/Sidebar';
import Banner from './components/Banner';
import CatSearch from './pages/category/CatSearch';
import CatAdd from './pages/category/CatAdd';
import Report from './components/Report';
import SubcatSearch from './pages/subcat/SubcatSearch';
import SubcatAdd from './pages/subcat/SubcatAdd';
import Price from './pages/Product/Price';
import Login from './pages/Auth/Login';
import Feedback from './pages/Order/Feedback';
import OrderDetails from './pages/Order/OrderDetails';
import Dinein from './pages/Order/Dine-in';
//import TopBar from './components/TopBar';
import ChangePassword from './pages/Auth/ChangePassword'; 
import OrderDetailPage from "./pages/Order/OrderDetailPage";
import RegisterResturant from "./pages/Resturant/AddResturant";
import RestaurantData from "./pages/Resturant/ResturantDetails";
import UserFeedback from "./pages/feedback/userfeedbacks";
import Feedback1 from "./pages/feedback/feedback1";
import DownloadOrdersPage from "./pages/Order/DownloadOrdersPage";

// import FeedbackForm from "./FeedBack/Feedbackform";

function App() {
  const [isAuthenticated, setIsAuthenticated] = useState(
    localStorage.getItem("token") ? true : false
  );
  const username = localStorage.getItem("username");
  const navigate = useNavigate();

  const handleLoginSuccess = (token) => {
    setIsAuthenticated(true);
    localStorage.setItem("token", token); 
    navigate('/dashboard'); 
  };
  if (!isAuthenticated) {
    return (
      <Routes>
        <Route path="/" element={<Login onLoginSuccess={handleLoginSuccess} />} />
        <Route path="*" element={<Navigate to="/" />} />
      </Routes>
    );
  }
  

  return (
    <div className="App">
      <div className="AppGlass">
      {isAuthenticated ? <Sidebar setIsAuthenticated={setIsAuthenticated} /> : <div></div>}
        <Routes>
          {!isAuthenticated ? (
            <Route path="/" element={<Login onLoginSuccess={handleLoginSuccess} />} />
          ) : (
            <>
             <Route path="/" element={<Navigate to="/dashboard" />} />
             <Route path="/dashboard" element={<MainDash username={username} />} />
             <Route path="/download-orders" element={<DownloadOrdersPage />} />
             <Route path="/resturant/add" element={<RegisterResturant />} />
             <Route path="/resturant/details" element={<RestaurantData />} />
             <Route path="/resturant/edit/:restaurantId" element={<RegisterResturant />} />
              {/* <Route path="/feedbackForm" element={<FeedbackForm />} /> */}
              <Route path="/product" element={<ProductSearch />} />
              <Route path="/product/productdetail/:id" element={<ProductAdd />} />
              <Route path="/product/add" element={<ProductAdd />} />
              <Route path="/price-update" element={<Price />} />
              <Route path="/categories" element={<CatSearch />} />
              <Route path="/add-category" element={<CatAdd />} />
              <Route path="/subcategories" element={<SubcatSearch />} />
              <Route path="/add-subcategory" element={<SubcatAdd />} />
             <Route path="/userfeedback" element={<UserFeedback />} />
             <Route path="/feedback1" element={<Feedback1 />} />
              <Route path="/order" element={<OrderDetails/>} />
              <Route path="/dining" element={<Dinein/>} />
               <Route path="/order/:id" element={<OrderDetailPage />} />
              <Route path="/banner" element={<Banner/>} />
              <Route path="/reports" element={<Report/>} />
              <Route path="/change-password" element={<ChangePassword />} />

            </>
          )}
        </Routes>
      </div>
    </div>
  );
}

function AppWrapper() {
  return (
    <BrowserRouter>
      <PrimeReactProvider>
        <App />
      </PrimeReactProvider>
    </BrowserRouter>
  );
}

export default AppWrapper;
